/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.types', [])
    .constant('types',
        {
            aggregation: {
                min: {
                    value: "MIN",
                    name: "aggregation.min"
                },
                max: {
                    value: "MAX",
                    name: "aggregation.max"
                },
                avg: {
                    value: "AVG",
                    name: "aggregation.avg"
                },
                sum: {
                    value: "SUM",
                    name: "aggregation.sum"
                },
                count: {
                    value: "COUNT",
                    name: "aggregation.count"
                },
                none: {
                    value: "NONE",
                    name: "aggregation.none"
                }
            },
            apiLimitTimeUnit: {
                "HOURS": {
                    value: "HOURS",
                    name: "api-limits.time-unit-hours"
                },
                "DAYS": {
                    value: "DAYS",
                    name: "api-limits.time-unit-days"
                }
            },
            authority: {
                "SYS_ADMIN": {
                    value: "SYS_ADMIN",
                    name: "user.sys-admin",
                    scope: 'system',
                    access: 'admin'
                },
                "SYS_USER": {
                    value: "SYS_USER",
                    name: "user.sys-user",
                    scope: 'system',
                    access: 'user'
                },
                "PROVIDER_ADMIN": {
                    value: "PROVIDER_ADMIN",
                    name: "user.provider-admin",
                    scope: 'provider',
                    access: 'admin'
                },
                "PROVIDER_USER": {
                    value: "PROVIDER_USER",
                    name: "user.provider-user",
                    scope: 'provider',
                    access: 'user'
                },
                "CUSTOMER_ADMIN": {
                    value: "CUSTOMER_ADMIN",
                    name: "user.customer-admin",
                    scope: 'customer',
                    access: 'admin'
                },
                "CUSTOMER_USER": {
                    value: "CUSTOMER_USER",
                    name: "user.customer-user",
                    scope: 'customer',
                    access: 'user'
                },
                "SUB_CUSTOMER_ADMIN": {
                    value: "SUB_CUSTOMER_ADMIN",
                    name: "user.sub-customer-admin",
                    scope: 'subCustomer',
                    access: 'admin'
                },
                "SUB_CUSTOMER_USER": {
                    value: "SUB_CUSTOMER_USER",
                    name: "user.sub-customer-user",
                    scope: 'subCustomer',
                    access: 'user'
                }
            },
            allAuthorities: [
                "SYS_ADMIN",
                "SYS_USER",
                "PROVIDER_ADMIN",
                "PROVIDER_USER",
                "CUSTOMER_ADMIN",
                "CUSTOMER_USER",
                "SUB_CUSTOMER_ADMIN",
                "SUB_CUSTOMER_USER"
            ],
            adminAuthorities: [
                "SYS_ADMIN",
                "PROVIDER_ADMIN",
                "CUSTOMER_ADMIN",
                "SUB_CUSTOMER_ADMIN"
            ],
            scope: {
                system: 'system',
                provider: 'provider',
                customer: 'customer',
                subCustomer: 'subCustomer'
            },
            access: {
                admin: 'admin',
                user: 'user'
            },
            serverErrorCode: {
                general: 2,
                authentication: 10,
                jwtTokenExpired: 11,
                permissionDenied: 20,
                invalidArguments: 30,
                badRequestParams: 31,
                itemNotFound: 32,
                subscriptionViolation: 40
            },
            entryPoints: {
                login: "/api/auth/login",
                tokenRefresh: "/api/auth/token",
                nonTokenBased: "/api/noauth"
            },
            entityType: {
                device: "DEVICE",
                application: "APPLICATION",
                gateway: "GATEWAY",
                gateway_group: "GATEWAY_GROUP",
                provider: "PROVIDER",
                customer: "CUSTOMER",
                subCustomer: "SUB_CUSTOMER",
                user: "USER",
                converter: "CONVERTER",
                integration: "INTEGRATION",
                provider_subscription: "PROVIDER_SUBSCRIPTION",
                customer_subscription: "CUSTOMER_SUBSCRIPTION",
                device_model: "DEVICE_MODEL",
                gateway_model: "GATEWAY_MODEL"
            },
            wsSubscriptionType: {
                stats: "STATS",
                state: "STATE"
            },
            entityTable: {
                entityField: {
                    createdTime: {
                        name: 'entity-field.created-time',
                        value: 'createdTime',
                        time: true
                    }
                },
                sortOrder: {
                    asc: {
                        value: 'ASC'
                    },
                    desc: {
                        value: 'DESC'
                    },
                    none: {
                        value: 'NONE'
                    }
                }
            },
            entityTypeTranslations: {
                "DEVICE": {
                    noEntities: 'device.no-devices-text',
                    selectedEntities: 'device.selected-devices',
                    add: 'device.add',
                    bulkProvisioning: 'device.bulk-provisioning-title',
                    details: 'device.device-details',
                    search: 'device.search',
                    name: 'device.device'
                },
                "APPLICATION": {
                    noEntities: 'application.no-applications-text',
                    selectedEntities: 'application.selected-applications',
                    add: 'application.add',
                    details: 'application.application-details',
                    search: 'application.search',
                    name: 'application.application'
                },
                "GATEWAY": {
                    noEntities: 'gateway.no-gateways-text',
                    selectedEntities: 'gateway.selected-gateways',
                    add: 'gateway.add',
                    bulkProvisioning: 'gateway.bulk-provisioning-title',
                    details: 'gateway.gateway-details',
                    search: 'gateway.search',
                    name: 'gateway.gateway'
                },
                "GATEWAY_GROUP": {
                    noEntities: 'gateway-group.no-gateway-groups-text',
                    selectedEntities: 'gateway-group.selected-gateway-groups',
                    add: 'gateway-group.add',
                    details: 'gateway-group.gateway-group-details',
                    search: 'gateway-group.search',
                    name: 'gateway-group.gateway-group'
                },
                "PROVIDER": {
                    noEntities: 'provider.no-providers-text',
                    selectedEntities: 'provider.selected-providers',
                    add: 'provider.add',
                    details: 'provider.provider-details',
                    search: 'provider.search',
                    name: 'provider.provider'
                },
                "CUSTOMER": {
                    noEntities: 'customer.no-customers-text',
                    selectedEntities: 'customer.selected-customers',
                    add: 'customer.add',
                    details: 'customer.customer-details',
                    search: 'customer.search',
                    name: 'customer.customer'
                },
                "SUB_CUSTOMER": {
                    noEntities: 'subCustomer.no-sub-customers-text',
                    selectedEntities: 'subCustomer.selected-sub-customers',
                    add: 'subCustomer.add',
                    details: 'subCustomer.sub-customer-details',
                    search: 'subCustomer.search',
                    name: 'subCustomer.subCustomer'
                },
                "USER": {
                    noEntities: 'user.no-users-text',
                    selectedEntities: 'user.selected-users',
                    add: 'user.add',
                    details: 'user.user-details',
                    search: 'user.search',
                    name: 'user.user'
                },
                "CONVERTER": {
                    noEntities: 'converter.no-converters-text',
                    selectedEntities: 'converter.selected-converters',
                    add: 'converter.add',
                    details: 'converter.converter-details',
                    search: 'converter.search',
                    name: 'converter.converter'
                },
                "INTEGRATION": {
                    noEntities: 'integration.no-integrations-text',
                    selectedEntities: 'integration.selected-integrations',
                    add: 'integration.add',
                    details: 'integration.integration-details',
                    search: 'integration.search',
                    name: 'integration.integration'
                },
                "PROVIDER_SUBSCRIPTION": {
                    noEntities: 'subscription.no-subscriptions-text',
                    selectedEntities: 'subscription.selected-subscriptions',
                    add: 'subscription.add',
                    details: 'subscription.subscription-details',
                    search: 'subscription.search',
                    name: 'subscription.subscription'
                },
                "CUSTOMER_SUBSCRIPTION": {
                    noEntities: 'subscription.no-subscriptions-text',
                    selectedEntities: 'subscription.selected-subscriptions',
                    add: 'subscription.add',
                    details: 'subscription.subscription-details',
                    search: 'subscription.search',
                    name: 'subscription.subscription'
                },
                "DEVICE_MODEL": {
                    noEntities: 'device-model.no-device-models-text',
                    selectedEntities: 'device-model.selected-device-models',
                    add: 'device-model.add',
                    details: 'device-model.device-model-details',
                    search: 'device-model.search',
                    name: 'device-model.device-model'
                },
                "GATEWAY_MODEL": {
                    noEntities: 'gateway-model.no-gateway-models-text',
                    selectedEntities: 'gateway-model.selected-gateway-models',
                    add: 'gateway-model.add',
                    details: 'gateway-model.gateway-model-details',
                    search: 'gateway-model.search',
                    name: 'gateway-model.gateway-model'
                }
            },
            converterType: {
                "CAYENNE_LPP": {
                    value: "CAYENNE_LPP",
                    name: "converter-type.cayenne-lpp"
                },
                "TEK_INDUSTRIAL_SENSOR": {
                    value: "TEK_INDUSTRIAL_SENSOR",
                    name: "converter-type.tek-industrial-sensor"
                },
                "TEK_HOME_SENSOR": {
                    value: "TEK_HOME_SENSOR",
                    name: "converter-type.tek-home-sensor"
                },
                "GLOBAL_SAT_LT100_SENSOR": {
                    value: "GLOBAL_SAT_LT100_SENSOR",
                    name: "converter-type.global-sat-lt100-sensor"
                },
                "ADEUNIS_915_RF_SENSOR": {
                    value: "ADEUNIS_915_RF_SENSOR",
                    name: "converter-type.adeunis-915-rf-sensor"
                },
                "LIBELIUM_SENSOR": {
                    value: "LIBELIUM_SENSOR",
                    name: "converter-type.libelium-sensor"
                },
                "SENSORO_SENSOR": {
                    value: "SENSORO_SENSOR",
                    name: "converter-type.sensoro-sensor"
                },
                "ADEUNIS_8046_RF_SENSOR": {
                    value: "ADEUNIS_8046_RF_SENSOR",
                    name: "converter-type.adeunis-8046-rf-sensor"
                },
                "CUSTOM": {
                    value: "CUSTOM",
                    name: "converter-type.custom"
                }
            },
            deviceClass: {
                "CLASS_A": {
                    value: "CLASS_A",
                    name: "device-class.class-a"
                },
                "CLASS_B": {
                    value: "CLASS_B",
                    name: "device-class.class-b"
                },
                "CLASS_C": {
                    value: "CLASS_C",
                    name: "device-class.class-c"
                }
            },
            gatewayFrequency: {
                "AS_923": {
                    value: "AS_923",
                    name: "gateway-frequency.as-923"
                },
                "AS_920_923": {
                    value: "AS_920_923",
                    name: "gateway-frequency.as-920-923"
                },
                "AS_923_925": {
                    value: "AS_923_925",
                    name: "gateway-frequency.as-923-925"
                },
                "US_902_928": {
                    value: "US_902_928",
                    name: "gateway-frequency.us-902-928",
                    info: {
                        frequencyBand: "902-928MHz",
                        channels: "64+8+8",
                        channelBwUp: "125/500kHz",
                        channelBwDn: "500kHz",
                        txPowerUp: "+20dBm (+30dBm allowed)",
                        txPowerDn: "+27dBm",
                        sfUp: "7-10",
                        dataRate: "980bps-21.9kbps",
                        linkBudgetUp: "154dB",
                        linkBudgetDn: "157dB"
                    }
                },
                "EU_863_870": {
                    value: "EU_863_870",
                    name: "gateway-frequency.eu-863-870",
                    info: {
                        frequencyBand: "867-869MHz",
                        channels: "10",
                        channelBwUp: "125/250kHz",
                        channelBwDn: "125kHz",
                        txPowerUp: "+14dBm",
                        txPowerDn: "+14dBm",
                        sfUp: "7-12",
                        dataRate: "250bps-50kbps",
                        linkBudgetUp: "155dB",
                        linkBudgetDn: "155dB"
                    }
                },
                "CN_470_510": {
                    value: "CN_470_510",
                    name: "gateway-frequency.cn-470-510",
                    info: {
                        frequencyBand: "470-510MHz",
                        channels: "96+48",
                        channelBwUp: "125/500kHz",
                        channelBwDn: "500kHz",
                        txPowerUp: "+20dBm (+30dBm allowed)",
                        txPowerDn: "+27dBm",
                        sfUp: "7-10",
                        dataRate: "980bps-21.9kbps",
                        linkBudgetUp: "154dB",
                        linkBudgetDn: "157dB"
                    }
                },
                "AU_915_928": {
                    value: "AU_915_928",
                    name: "gateway-frequency.au-915-928",
                    info: {
                        frequencyBand: "915-928MHz",
                        channels: "64+8+8",
                        channelBwUp: "125/500kHz",
                        channelBwDn: "500kHz",
                        txPowerUp: "+20dBm (+30dBm allowed)",
                        txPowerDn: "+27dBm",
                        sfUp: "7-10",
                        dataRate: "980bps-21.9kbps",
                        linkBudgetUp: "154dB",
                        linkBudgetDn: "157dB"
                    }
                },
                "RU_864_870": {
                    value: "RU_864_870",
                    name: "gateway-frequency.ru-864-870",
                    info: {
                        frequencyBand: "864-870MHz",
                        dataRate: "300bps-5kbps",
                    }
                },
                "IN_865_867": {
                    value: "IN_865_867",
                    name: "gateway-frequency.in-865-867",
                    info: {
                        frequencyBand: "865-867MHz",
                        dataRate: "300bps-5kbps",
                    }
                },
                "ISR_915_917": {
                    value: "ISR_915_917",
                    name: "gateway-frequency.isr-915-917",
                    info: {
                        frequencyBand: "915-917MHz",
                        dataRate: "300bps-5kbps",
                    }
                },
                "KR_920_923": {
                    value: "KR_920_923",
                    name: "gateway-frequency.kr-920-923",
                    info: {
                        frequencyBand: "920-923MHz",
                        dataRate: "300bps-5kbps",
                    }
                }
            },
            integrationType: {
                "HTTP": {
                    value: "HTTP",
                    name: "integration-type.http"
                },
                "MQTT": {
                    value: "MQTT",
                    name: "integration-type.mqtt"
                },
                "THINGSBOARD": {
                    value: "THINGSBOARD",
                    name: "integration-type.thingsboard"
                },
                "AZURE": {
                    value: "AZURE",
                    name: "integration-type.azure"
                }
            },
            configurationType: {
                "GENERAL": {
                    value: "GENERAL",
                    name: "configuration-type.general"
                },
                "FREQUENCY": {
                    value: "FREQUENCY",
                    name: "configuration-type.frequency"
                },
                "ANTENNA": {
                    value: "ANTENNA",
                    name: "configuration-type.antenna"
                },
                "UPGRADE_SERVERS": {
                    value: "UPGRADE_SERVERS",
                    name: "configuration-type.upgrade-servers"
                },
                "AUTOMATIC_UPDATES": {
                    value: "AUTOMATIC_UPDATES",
                    name: "configuration-type.automatic-updates"
                }
            },
            contentType: {
                "JSON": {
                    value: "JSON",
                    name: "content-type.json",
                    code: "json"
                },
                "TEXT": {
                    value: "TEXT",
                    name: "content-type.text",
                    code: "text"
                },
                "BINARY": {
                    value: "BINARY",
                    name: "content-type.binary",
                    code: "text"
                }
            },
            fileType: {
                CSV: {
                    mimeType: 'attachment/csv',
                    extension: 'csv'
                },
                PEM: {
                    mimeType: 'attachment/pem',
                    extension: 'pem'
                }
            },
            configScope: {
                gateway: {
                    value: "gateway",
                    name: "configuration.gateway-scope"
                },
                group: {
                    value: "group",
                    name: "configuration.group-scope"
                }
            },
            configSyncStatus: {
                synced: {
                    value: "synced",
                    name: "configuration.synced"
                },
                notSynced: {
                    value: "notSynced",
                    name: "configuration.not-synced"
                }
            },
            gatewayCommand: {
                reboot: {
                    value: "reboot",
                    name: "gateway-command.reboot"
                },
                ping: {
                    value: "ping",
                    name: "gateway-command.ping"
                },
                getPublicKey: {
                    value: "getPublicKey",
                    name: "gateway-command.get-public-key"
                },
                reverseSsh: {
                    value: "reverseSsh",
                    name: "gateway-command.reverse-ssh",
                    defaultOptions: "-f -N -T -R"
                },
                stopReverseSsh: {
                    value: "stopReverseSsh",
                    name: "gateway-command.stop-reverse-ssh"
                },
                executeScript: {
                    value: "executeScript",
                    name: "gateway-command.execute-script"
                },
                getAntennasCount: {
                    value: "getAntennasCount",
                    name: "gateway-command.get-antennas-count"
                }
            },
            gatewayCommandNotSupported: {
                value: 'not_supported',
                name: 'gateway-command.not-supported'
            },
            backupsGatewayCommand: {
                getBackups: {
                    value: 'getBackups'
                },
                restoreBackup: {
                    value: 'restoreBackup'
                },
                createBackup: {
                    value: 'createBackup'
                }
            },
            firewallGatewayCommand: {
                getFirewallConfiguration: {
                    value: 'getFirewallConfiguration'
                },
                setFirewallConfiguration: {
                    value: 'setFirewallConfiguration'
                }
            },
            spectrumAnalyzerCommand: {
                setSpectrumAnalyzerParams: {
                    value: 'setSpectrumAnalyzerParams'
                },
                getSpectrumAnalyzerOutput: {
                    value: 'getSpectrumAnalyzerOutput'
                }
            },
            spectralScanCommand: {
                getSpectralScanParams: {
                    value: 'getSpectralScanParams'
                },
                executeSpectralScan: {
                    value: 'executeSpectralScan'
                },
                getSpectralScanProgress: {
                    value: 'getSpectralScanProgress'
                },
                getSpectralScanResults: {
                    value: 'getSpectralScanResults'
                }
            },
            radioStatisticsCommand: {
                getRadioStatistics: {
                    value: 'getRadioStatistics'
                },
                resetRadioStatisticsCounters: {
                    value: 'resetRadioStatisticsCounters'
                }
            },
            gatewayInfoCommand: {
                getGatewayInfo: {
                    value: 'getGatewayInfo'
                }
            },
            softwareCommand: {
                getSoftwareVersions: {
                    value: 'getSoftwareVersions'
                },
                getBspStatus: {
                    value: 'getBspStatus'
                },
                getUpgradableSoftware: {
                    value: 'getUpgradableSoftware'
                },
                getInstallableSoftware: {
                    value: 'getInstallableSoftware'
                },
                upgradeSoftware: {
                    value: 'upgradeSoftware'
                },
                installSoftware: {
                    value: 'installSoftware'
                },
                getInstallStatus: {
                    value: 'getInstallStatus'
                },
                getUpgradeStatus: {
                    value: 'getUpgradeStatus'
                },
                getLastInstallUpgradeStatus: {
                    value: 'getLastInstallUpgradeStatus'
                }
            },
            wirelessModemCommand: {
                getWmDeviceInformation: {
                    value: 'getWmDeviceInformation'
                },
                getWmHomeNetworkBranch: {
                    value: 'getWmHomeNetworkBranch'
                },
                getWmRfInformation: {
                    value: 'getWmRfInformation'
                },
                getWmActiveProfileParameters: {
                    value: 'getWmActiveProfileParameters'
                },
                getWmCallStatistics: {
                    value: 'getWmCallStatistics'
                },
                getWmApns: {
                    value: 'getWmApns'
                },
                addWmApn: {
                    value: 'addWmApn'
                },
                deleteWmApn: {
                    value: 'deleteWmApn'
                },
                getWmStatusApn: {
                    value: 'getWmStatusApn'
                },
                updateWmApn: {
                    value: 'updateWmApn'
                },
                installWmLocalFirmware: {
                    value: 'installWmLocalFirmware'
                },
                installWmLocalFirmwareStatus: {
                    value: 'installWmLocalFirmwareStatus'
                },
                wipeUploadDirectory: {
                    value: 'wipeUploadDirectory'
                },
                upgradeWmFirmware: {
                    value: 'upgradeWmFirmware'
                },
                uploadRemoteWmFirmware: {
                    value: 'uploadRemoteWmFirmware'
                }
            },
            wanCommand: {
                getConnectivityTypes: {
                    value: 'getConnectivityTypes'
                },
                setPreferredFallbackConnectivityType: {
                    value: 'setPreferredFallbackConnectivityType'
                },
                setPreferredPingIpAddress: {
                    value: 'setPreferredPingIpAddress'
                },
                getPreferredPingIpAddress: {
                    value: 'getPreferredPingIpAddress'
                }
            },
            fileTransferCommand: {
                fileUploadStart: {
                    value: 'fileUploadStart'
                },
                fileUploadChunk: {
                    value: 'fileUploadChunk'
                },
                fileUploadStop: {
                    value: 'fileUploadStop'
                }
            },
            spectrumAnalyzerAntenna: {
                antenna0: {
                    value: 'antenna0',
                    name: 'spectrum-analyzer.antenna0'
                },
                antenna1: {
                    value: 'antenna1',
                    name: 'spectrum-analyzer.antenna1'
                },
                both: {
                    value: 'both',
                    name: 'spectrum-analyzer.antenna-both'
                }
            },
            spectralScanAntenna: {
                antenna0: {
                    value: 'antenna0',
                    name: 'spectrum-analyzer.antenna0'
                },
                antenna1: {
                    value: 'antenna1',
                    name: 'spectrum-analyzer.antenna1'
                }
            },
            firewall: {
                chain: {
                    input: 'INPUT',
                    output: 'OUTPUT'
                },
                target: {
                    accept: 'ACCEPT',
                    drop: 'DROP',
                    reject: 'REJECT'
                }
            },
            alarmRuleScope: {
                gateway: 'gateway',
                device: 'device'
            },
            gwAlarmRuleTriggerType: {
                "GW_OFFLINE": {
                    value: "GW_OFFLINE",
                    name: "alarm-rule.trigger-gw-offline"
                },
                "GW_ONLINE": {
                    value: "GW_ONLINE",
                    name: "alarm-rule.trigger-gw-online"
                },
                "GW_ALARM": {
                    value: "GW_ALARM",
                    name: "alarm-rule.trigger-gw-alarm",
                    isEvent: true
                },
                "GW_FAULT": {
                    value: "GW_FAULT",
                    name: "alarm-rule.trigger-gw-fault",
                    isEvent: true
                },
                "GW_EVENT": {
                    value: "GW_EVENT",
                    name: "alarm-rule.trigger-gw-event",
                    isEvent: true
                }
            },
            devAlarmRuleTriggerType: {
                "DEV_OFFLINE": {
                    value: "DEV_OFFLINE",
                    name: "alarm-rule.trigger-dev-offline"
                },
                "DEV_ONLINE": {
                    value: "DEV_ONLINE",
                    name: "alarm-rule.trigger-dev-online"
                },
                "INTEGRATION_IS_CONNECTED": {
                    value: "INTEGRATION_IS_CONNECTED",
                    name: "alarm-rule.trigger-integration-connected"
                },
                "INTEGRATION_IS_DISCONNECTED": {
                    value: "INTEGRATION_IS_DISCONNECTED",
                    name: "alarm-rule.trigger-integration-disconnected"
                }
            },
            notificationType: {
                "EMAIL": {
                    value: "EMAIL",
                    name: "alarm-rule.notification-email"
                },
                "SMS": {
                    value: "SMS",
                    name: "alarm-rule.notification-sms"
                }
            },
            eventType: {
                "ALARM": {
                    value: "ALARM",
                    name: "event.alarms",
                    typeName: "event.alarm"
                },
                "FAULT": {
                    value: "FAULT",
                    name: "event.faults",
                    typeName: "event.fault"
                },
                "EVENT": {
                    value: "EVENT",
                    name: "event.events",
                    typeName: "event.event"
                },
                "ONLINE": {
                    value: "ONLINE",
                    name: "event.online",
                    typeName: "event.online"
                },
                "OFFLINE": {
                    value: "OFFLINE",
                    name: "event.offline",
                    typeName: "event.offline"
                }
            },
            severity: {
                "CRITICAL": {
                    value: "CRITICAL",
                    name: "event.severity-critical"
                },
                "MAJOR": {
                    value: "MAJOR",
                    name: "event.severity-major"
                },
                "MINOR": {
                    value: "MINOR",
                    name: "event.severity-minor"
                }
            },
            eventState: {
                "CLEAR": {
                    value: "CLEAR",
                    name: "event.state-clear"
                },
                "RAISED": {
                    value: "RAISED",
                    name: "event.state-raised"
                }
            },
            authMethodType: {
                "NO_AUTH": {
                    value: "NO_AUTH",
                    name: "integration.auth-method-type.no-auth"
                },
                "BASIC_AUTH": {
                    value: "BASIC_AUTH",
                    name: "integration.auth-method-type.basic-auth"
                }
            },
            credentialsTypes: {
                basic: {
                    value: 'BASIC',
                    name: 'credentials.basic'
                },
                x509_certificate: {
                    value: 'X509_CERTIFICATE',
                    name: 'credentials.x509_certificate'
                }
            },
            chMaskOptions: {
                "notDefined": {
                    name: "networkSettings.not-defined-channel-mask",
                    value: "notDefined"
                },
                "channels64": {
                    name: "networkSettings.64-channel",
                    value: "channels64"
                },
                "channels8": {
                    name: "networkSettings.8-channel",
                    value: "channels8"
                },
                "custom": {
                    name: "networkSettings.custom-channel-mask",
                    value: "custom"
                }
            },
            channelMaskOptionsData: {
                "channels8": [
                    {
                        chMask: '0x0001',
                        chMaskCntl: '0x07'
                    },
                    {
                        chMask: '0x00FF',
                        chMaskCntl: '0x00'
                    }
                ],
                "channels64": [
                    {
                        chMask: '0x00FF',
                        chMaskCntl: '0x06'
                    }
                ],
                "notDefined": []
            },
            valueType: {
                string: {
                    value: "string",
                    name: "value.string",
                    icon: "mdi:format-text"
                },
                integer: {
                    value: "integer",
                    name: "value.integer",
                    icon: "mdi:numeric"
                },
                double: {
                    value: "double",
                    name: "value.double",
                    icon: "mdi:numeric"
                },
                boolean: {
                    value: "boolean",
                    name: "value.boolean",
                    icon: "mdi:checkbox-marked-outline"
                }
            },
            smsProvider: {
                "TWILIO": {
                    value: "TWILIO",
                    name: "admin.sms-twilio"
                }
            },
            subscriptionError: {
                "LIMIT_REACHED": {
                    "MAX_PROVIDER_GATEWAYS": "subscription-error.limit-reached.max-provider-gateways",
                    "MAX_CUSTOMER_GATEWAYS": "subscription-error.limit-reached.max-customer-gateways",
                    "MAX_PROVIDER_APPLICATIONS": "subscription-error.limit-reached.max-provider-applications",
                    "MAX_CUSTOMER_APPLICATIONS": "subscription-error.limit-reached.max-customer-applications",
                    "MAX_PROVIDER_DEVICES": "subscription-error.limit-reached.max-provider-devices",
                    "MAX_CUSTOMER_DEVICES": "subscription-error.limit-reached.max-customer-devices",
                    "MAX_PROVIDER_INTEGRATIONS": "subscription-error.limit-reached.max-provider-integrations",
                    "MAX_CUSTOMER_INTEGRATIONS": "subscription-error.limit-reached.max-customer-integrations",
                    "MAX_CUSTOMERS": "subscription-error.limit-reached.max-customers",
                    "MAX_SUB_CUSTOMERS": "subscription-error.limit-reached.max-sub-customers",
                    "PROVIDER_SUBSCRIPTION_VIOLATION": "subscription-error.limit-reached.provider-subscription-violation",
                    "CUSTOMER_SUBSCRIPTION_VIOLATION": "subscription-error.limit-reached.customer-subscription-violation"
                }
            },
            software: {
                mode: {
                    swList: {
                        title: 'software.software-versions',
                        noDataPrompt: 'software.no-components-prompt'
                    },
                    upgradableList: {
                        title: 'software.upgradable-software',
                        selection: true,
                        upgrade: true,
                        showNewVer: true,
                        hasSpecial: true,
                        noDataPrompt: 'software.no-upgradable-prompt',
                        selectedText: 'software.selected-upgradable'
                    },
                    installableList: {
                        title: 'software.installable-software',
                        selection: true,
                        upgrade: false,
                        noDataPrompt: 'software.no-installable-prompt',
                        selectedText: 'software.selected-installable'
                    }
                },
                verType: {
                    short: {
                        name: 'software.ver-type-short',
                        value: 'short',
                        id: 0,
                    },
                    full: {
                        name: 'software.ver-type-full',
                        value: 'full',
                        id: 1
                    }
                },
                bspStatus: {
                    0: {
                        name: 'software.bsp-status-success'
                    },
                    90000: {
                        name: 'software.bsp-status-upgrade-busy'
                    },
                    90001: {
                        name: 'software.bsp-status-bsp-upgrade-busy'
                    },
                    90002: {
                        name: 'software.bsp-status-bsp-status-never-performed'
                    },
                    90003: {
                        name: 'software.bsp-status-bsp-latest'
                    },
                    90004: {
                        name: 'software.bsp-status-bsp-upgrade-error'
                    },
                    1000001: {
                        name: 'software.bsp-status-break-lock'
                    }
                },
                upgradeStatus: {
                    0: {
                        name: "software.upgrade-status-success"
                    },
                    1: {
                        name: "software.upgrade-status-could-not-set-default-destination"
                    },
                    2: {
                        name: "software.upgrade-status-error-parsing-config-file"
                    },
                    3: {
                        name: "software.upgrade-status-could-not-obtain-temporary-directory"
                    },
                    4: {
                        name: "software.upgrade-status-could-not-obtain-administrative-lock"
                    },
                    5: {
                        name: "software.upgrade-status-unsatisfied-dependencies"
                    },
                    6: {
                        name: "software.upgrade-status-is-essential"
                    },
                    7: {
                        name: "software.upgrade-status-has-dependents"
                    },
                    8: {
                        name: "software.upgrade-status-has-no-candidate"
                    },
                    9: {
                        name: "software.upgrade-status-package-has-no-available-architecture"
                    },
                    10: {
                        name: "software.upgrade-status-not-trusted"
                    },
                    11: {
                        name: "software.upgrade-status-download-error"
                    },
                    12: {
                        name: "software.upgrade-status-conflicts"
                    },
                    13: {
                        name: "software.upgrade-status-already-installed"
                    },
                    14: {
                        name: "software.upgrade-status-dependencies"
                    },
                    15: {
                        name: "software.upgrade-status-no-downgrade"
                    },
                    16: {
                        name: "software.upgrade-status-out-of-space"
                    },
                    17: {
                        name: "software.upgrade-status-bad-signature"
                    },
                    18: {
                        name: "software.upgrade-status-md5-error"
                    },
                    19: {
                        name: "software.upgrade-status-internal-error"
                    },
                    65280: {
                        name: "software.upgrade-status-unknown-error"
                    },
                    90000: {
                        name: "software.upgrade-status-tt-upgrade-busy"
                    },
                    90001: {
                        name: "software.upgrade-status-tt-bsp-upgrade-busy"
                    },
                    90002: {
                        name: "software.upgrade-status-tt-bsp-status-never-performed"
                    },
                    90003: {
                        name: "software.upgrade-status-tt-bsp-latest"
                    },
                    90004: {
                        name: "software.upgrade-status-tt-bsp-upgrade-error"
                    },
                    90005: {
                        name: "software.upgrade-status-tt-general-upgrade-failure"
                    },
                    1000001: {
                        name: "software.upgrade-status-start-upgrade"
                    }
                },
                installStatus: {
                    0: {
                        name: "software.install-status-success"
                    },
                    1: {
                        name: "software.install-status-could-not-set-default-destination"
                    },
                    2: {
                        name: "software.install-status-error-parsing-config-file"
                    },
                    3: {
                        name: "software.install-status-could-not-obtain-temporary-directory"
                    },
                    4: {
                        name: "software.install-status-could-not-obtain-administrative-lock"
                    },
                    5: {
                        name: "software.install-status-unsatisfied-dependencies"
                    },
                    6: {
                        name: "software.install-status-is-essential"
                    },
                    7: {
                        name: "software.install-status-has-dependents"
                    },
                    8: {
                        name: "software.install-status-has-no-candidate"
                    },
                    9: {
                        name: "software.install-status-package-has-no-available-architecture"
                    },
                    10: {
                        name: "software.install-status-not-trusted"
                    },
                    11: {
                        name: "software.install-status-download-error"
                    },
                    12: {
                        name: "software.install-status-conflicts"
                    },
                    13: {
                        name: "software.install-status-already-installed"
                    },
                    14: {
                        name: "software.install-status-dependencies"
                    },
                    15: {
                        name: "software.install-status-no-downgrade"
                    },
                    16: {
                        name: "software.install-status-out-of-space"
                    },
                    17: {
                        name: "software.install-status-bad-signature"
                    },
                    18: {
                        name: "software.install-status-md5-error"
                    },
                    19: {
                        name: "software.install-status-internal-error"
                    },
                    65280: {
                        name: "software.install-status-unknown-error"
                    },
                    90000: {
                        name: "software.install-status-tt-install-busy"
                    },
                    90005: {
                        name: "software.install-status-tt-general-install-failure"
                    },
                    1000001: {
                        name: "software.install-status-start-install"
                    }
                }
            },
            translate: {
                customTranslationsPrefix: "custom."
            },
            gatewayMsgType: {
                "GW_STATISTICS": {
                    value: "GW_STATISTICS",
                    name: "gateway-log.gw-statistics",
                },
                "GW_ALARM_EVENT": {
                    value: "GW_ALARM_EVENT",
                    name: "gateway-log.gw-alarm-event"
                },
                "GW_RPC_COMMAND": {
                    value: "GW_RPC_COMMAND",
                    name: "gateway-log.gw-rpc-command"
                },
                "GW_RPC_RESPONSE": {
                    value: "GW_RPC_RESPONSE",
                    name: "gateway-log.gw-rpc-response"
                },
                "GW_CONFIGURATION_UPDATE": {
                    value: "GW_CONFIGURATION_UPDATE",
                    name: "gateway-log.gw-configuration-update"
                },
                "GW_CONFIGURATION_REQUEST": {
                    value: "GW_CONFIGURATION_REQUEST",
                    name: "gateway-log.gw-configuration-request"
                },
                "GW_EVENT": {
                    value: "GW_EVENT",
                    name: "gateway-log.gw-event"
                },
                "DEVICE_ALARM_EVENT": {
                    value: "DEVICE_ALARM_EVENT",
                    name: "gateway-log.device-alarm-event"
                },
                "JOIN_REQUEST": {
                    value: "JOIN_REQUEST",
                    name: "gateway-log.join-request"
                },
                "JOIN_ACCEPT": {
                    value: "JOIN_ACCEPT",
                    name: "gateway-log.join-accept"
                },
                "UNCONFIRMED_DATA_UP": {
                    value: "UNCONFIRMED_DATA_UP",
                    name: "gateway-log.unconfirmed-data-up"
                },
                "UNCONFIRMED_DATA_DOWN": {
                    value: "UNCONFIRMED_DATA_DOWN",
                    name: "gateway-log.unconfirmed-data-down"
                },
                "CONFIRMED_DATA_UP": {
                    value: "CONFIRMED_DATA_UP",
                    name: "gateway-log.confirmed-data-up"
                },
                "CONFIRMED_DATA_DOWN": {
                    value: "CONFIRMED_DATA_DOWN",
                    name: "gateway-log.confirmed-data-down"
                }
            },
            bulk_provisioning: {
                gw_id_column: "GW ID",
                device_eui_column: "DEVEUI"
            }
        }
    ).name;



// WEBPACK FOOTER //
// ./src/app/common/types.constant.js